module.exports = __webpack_public_path__ + "media/img/text-487ef4ebbe28790856aa399e9bf688d8.svg";